module.exports = __webpack_public_path__ + "img/tweed_20_20_b.b1aea2a5.jpg";